module.exports = __webpack_public_path__ + "static/media/Group (4).723ec381.svg";